<template>
  <div class="envio-list-container">
    <class class="row">
      <div class="col">
        <KeyRound /> ID
      </div>
      <div class="col">
        <Store /> Expendeduria
      </div>
      <div class="col">
        <SquareCheck /> Estado
      </div>
      <div class="col">
        <CalendarClock /> Fecha
      </div>
    </class>
    <div class="row">
      <div class="col">
        <div class="accordion" id="accordionFaq">
          <!-- <div v-for="(item, index) in faqs" :key="index" class="accordion-item"> -->
            
          <component
            v-for="envio in store.sortedEnvios"
            :is="EnvioItemComponent"
            :key="envio.id"
            :envio="envio"
          />
            
          </div>
        </div>
      </div>
    </div>
  
</template>

<script setup lang="ts">
import { useEnviosStore } from '@/stores/useEnvioStore';
import IncidentDetailComponent from './IncidentDetailComponent.vue';
import { Envio } from '@/types/envioTypes';
//import PaginationControls from '@/core/components/PaginationControls.vue';
import { onMounted } from 'vue';
import EnvioItemComponent from './EnvioItemComponent.vue';
import { Calculator, Store, CalendarClock, SquareCheck, KeyRound, Pencil } from 'lucide-vue-next';

const store = useEnviosStore();

// Carga inicial
onMounted(async () => {
  if (!store.envios.length) {
    await store.fetchEnvios();
  }
});
</script>

<style scoped lang="scss">
.envio-list-container {
  position: relative;
  min-height: 300px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-body {
  ul {
    li {
      margin-bottom: 0.5rem;
      strong {
        display: inline-block;
        width: 120px;
      }
    }
  }
}
</style>